// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setActivitiesList,
  setActivitiesStatistics,
  deleteActivities
} from 'src/store/modules/activities/actionCreators'

const initialState = {
  activitiesList: [],
  activitiesStatistics: {}
}

export default handleActions(
  {
    [`${setActivitiesList}`](state: any, { payload: activitiesList }: any) {
      return {
        ...state,
        activitiesList
      }
    },

    [`${setActivitiesStatistics}`](
      state: any,
      { payload: activitiesStatistics }: any
    ) {
      return {
        ...state,
        activitiesStatistics
      }
    },

    [`${deleteActivities}`]() {
      return initialState
    }
  },
  initialState
)
